import { useEffect, useState } from "react";
import { ChevronUp } from "lucide-react";

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!visible) return null;

  return (
    <button
  onClick={scrollTop}
  style={{
    position: "fixed",
    bottom: "25px",
    right: "25px",
    width: "52px",
    height: "52px",
    borderRadius: "50%",
    border: "none",
    cursor: "pointer",
    background: "#0d6efd",
    color: "#fff",
    boxShadow: "0 8px 20px rgba(0,0,0,.25)",
    zIndex: 9999,

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    padding: 0,
    lineHeight: 0,
  }}
>
  <ChevronUp
    size={24}
    style={{
      display: "block",
      flexShrink: 0,
    }}
  />
</button>
  );
}